{
 "_meta": {
  "locale": "it",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Adesso",
  "people": "Persone",
  "cases": "Pratiche",
  "agenda": "Agenda",
  "reviews": "Revisioni",
  "prospects": "Prospezione",
  "insights": "Analisi",
  "data": "Dati e sicurezza",
  "settings": "Impostazioni",
  "lens": "Lente"
 },
 "common": {
  "save": "Salva",
  "cancel": "Annulla",
  "close": "Chiudi",
  "search": "Cerca",
  "today": "Oggi",
  "tomorrow": "Domani",
  "new": "Nuovo",
  "edit": "Modifica",
  "delete": "Elimina"
 },
 "settings": {
  "title": "Impostazioni",
  "language": "Lingua",
  "region": "Mercato / regione",
  "theme": "Aspetto"
 },
 "people": {
  "title": "Persone",
  "new": "Nuova persona"
 },
 "today": {
  "agenda_title": "Oggi"
 },
 "lens": {
  "placeholder": "Cerca persone, prospect, pratiche — o digita un comando"
 }
}